import Axios from 'axios';
import * as humps from 'humps';

const useAuthClient = () => {
  const client = Axios.create({
    baseURL: process.env.REACT_APP_HELLOBAR_API_URL + '/api/hellomail',
    transformRequest: [
      (data) => {
        return data instanceof FormData ? data : humps.decamelizeKeys(data);
      },
      ...(Axios.defaults.transformRequest)
    ],
    transformResponse: [
      ...(Axios.defaults.transformResponse),
      (data) => (data instanceof Blob ? data : humps.camelizeKeys(data))
    ],
    headers: {
      "Content-Type": "application/json",
      xsrfCookieName: "X-CSRF-Token",
      xsrfHeaderName: "X-CSRF-Token",
      withCredentials: true
    }
  })

  return {
    signIn: async ({ email, password }) => {
      // TODO: refactor the host for the path and response handling

      const response = await client.post(
        "authenticate",
        {
          email: email,
          password: password
        },
        { withCredentials: true }
      );

      const attributes = response.data;
      return attributes;
    },
    cookieSignIn: async () => {
      const response = await client.post(
        "cookie_authenticate",
        {},
        { withCredentials: true }
      );

      const attributes = response.data;
      return attributes;
    },

    signUp: async ({ email, password }) => {
      const response = await client.post(
        "sign_up",
        {
          email,
          password
        },
        { withCredentials: true }
      );

      const attributes = response.data;
      return attributes;
    },
    confirmAccount: async (payload) => {
      // TODO: axios request here
    },
    forgotPassword: async (payload) => {
      // TODO: axios request here
    },
    resetPassword: async (payload) => {
      // TODO: axios request here
    },

    signOut: () => {
      return new Promise((resolve) => {
        localStorage.removeItem("hm-state");
        resolve(); // pretend async to minify warnings and errors in React

        // redirect to hellobar.com and sign out
        const form = document.createElement("form");
        document.body.appendChild(form);
        form.action = process.env.REACT_APP_HELLOBAR_API_URL + "/api/hellomail/cookie_sign_out";
        form.method = "POST";
        form.submit();
      });
    }
  }
};

export default useAuthClient;
